import { Box, Button, Grid, Paper, TextField, Typography, useMediaQuery, useTheme, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import useAuth from '../hooks/useAuth';
import axios from "../api/axios"
import { useEffect, useState } from "react";
import ExportButtons from "./ExportButtons";

export default function Intervalo1(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [desde, setDesde] = useState("")
    const [hasta, setHasta] = useState("")
    const { auth } = useAuth();
    const [datos, setDatos] = useState([])
    const [cargando, setCargando] = useState(false)
    const [mensaje, setMensaje] = useState("")

    useEffect(() => {
        setDesde(getDesde())
        setHasta(getHasta())
    }, [])

    const getDesde = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();
        if (mm < 10) { mm = '0' + mm; }
        return yyyy + '-' + mm + '-01';
    }

    const getHasta = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();
        if (mm == 12) { mm = 1; yyyy++; } else { mm++; }
        let prox = new Date(yyyy, (mm - 1), 1);
        prox.setDate(prox.getDate() - 1)
        mm = prox.getMonth() + 1;
        yyyy = prox.getFullYear();
        let dd = prox.getDate();
        if (mm < 10) { mm = '0' + mm; }
        if (dd < 10) { dd = '0' + dd; }
        return yyyy + '-' + mm + '-' + dd;
    }

    const handleClick = async () => {
        setCargando(true)
        setMensaje("")
        setDatos([])
        try {
            const respuesta = await axios.post("reportes/ganancias", {
                inversionista: auth.inversionista,
                oficial: 0,
                desde: desde,
                hasta: hasta
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta === "S") {
                if (data.data && data.data.length > 0) {
                    setDatos(data.data)
                } else {
                    setMensaje("No se encontraron registros en el rango seleccionado")
                }
            } else {
                setMensaje(data.mensaje || "Error al generar el reporte")
            }
        } catch (error) {
            console.log(error)
            setMensaje("Error de conexion al generar el reporte")
        }
        setCargando(false)
    }

    const columnsExport = datos.length > 0
        ? Object.keys(datos[0]).map(key => ({
            header: key.replace(/_/g, ' ').toUpperCase(),
            field: key,
            type: typeof datos[0][key] === 'number' && key.toLowerCase().includes('monto') ? 'money' : undefined
        }))
        : [];

    return (
        <Box sx={{
            minHeight: "100vh",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: isMobile ? 1.5 : 2,
            pt: isMobile ? 2 : 2
        }}>
            <Paper sx={{
                width: isMobile ? '100%' : '400px',
                maxWidth: '100%',
                p: isMobile ? 2 : 3,
                borderRadius: 2,
                boxShadow: 3,
                border: '1px solid rgba(30, 58, 95, 0.1)',
                mb: 3
            }}>
                <Box sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: 1,
                    p: isMobile ? 1.5 : 2,
                    mb: isMobile ? 2 : 3,
                    mx: isMobile ? -2 : -3,
                    mt: isMobile ? -2 : -3
                }}>
                    <Typography
                        variant={isMobile ? "subtitle1" : "h6"}
                        sx={{ color: 'white', fontWeight: 600, textAlign: 'center' }}
                    >
                        Reporte de Ganancias
                    </Typography>
                </Box>

                <Grid container spacing={isMobile ? 1.5 : 2}>
                    <Grid item xs={12}>
                        <TextField fullWidth size={isMobile ? 'small' : 'medium'} type="date" label="Desde" value={desde}
                            onChange={(e) => setDesde(e.target.value)} InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField fullWidth size={isMobile ? 'small' : 'medium'} type="date" label="Hasta" value={hasta}
                            onChange={(e) => setHasta(e.target.value)} InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="center" sx={{ mt: isMobile ? 1 : 2 }}>
                            <Button variant="contained" size={isMobile ? "medium" : "large"} onClick={handleClick}
                                fullWidth={isMobile} disabled={cargando}
                                sx={{
                                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                                    py: isMobile ? 1.25 : 1.5, fontWeight: 600,
                                    '&:hover': { background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)' }
                                }}
                            >
                                {cargando ? <CircularProgress size={24} color="inherit" /> : "Generar reporte"}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            {mensaje && (
                <Typography sx={{ color: '#666', mb: 2 }}>{mensaje}</Typography>
            )}

            {datos.length > 0 && (
                <Paper sx={{ width: '100%', maxWidth: '1200px', p: 2, borderRadius: 2, boxShadow: 3 }}>
                    <ExportButtons data={datos} columns={columnsExport} filename="ganancias" title="Reporte de Ganancias" />
                    <TableContainer sx={{ maxHeight: 500 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {Object.keys(datos[0]).map(key => (
                                        <TableCell key={key} sx={{ fontWeight: 'bold', backgroundColor: '#1e3a5f', color: 'white', whiteSpace: 'nowrap' }}>
                                            {key.replace(/_/g, ' ').toUpperCase()}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {datos.map((row, i) => (
                                    <TableRow key={i} sx={{ '&:nth-of-type(even)': { backgroundColor: '#f5f7fa' } }}>
                                        {Object.values(row).map((val, j) => (
                                            <TableCell key={j} sx={{ whiteSpace: 'nowrap' }}>
                                                {typeof val === 'number' ? val.toLocaleString('en-US', { minimumFractionDigits: 2 }) : (val || '')}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Typography sx={{ mt: 1, color: '#666', fontSize: '0.85rem' }}>
                        Total registros: {datos.length}
                    </Typography>
                </Paper>
            )}
        </Box>
    )
}
